module.exports = __webpack_public_path__ + "statics/img/UserReviews-4.3ed88bef.png";